var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('typography-default'),_c('typography-display'),_c('typography-blockquotes'),_c('typography-list'),_c('typography-description')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }